import { calculatePayout } from '../rules/payouts';
import { playNumberDisplay } from '../models/Play';

export interface PlayWinSource {
  id?: string;
  type?: string;
  number?: string;
  n?: string;
  number2?: string | null;
  stake?: number;
  payout?: number;
}

export function buildPlayWinNotification(play: PlayWinSource, lang: string) {
  const es = lang === 'es';
  const number = playNumberDisplay({
    type: play.type,
    number: play.number ?? play.n ?? '',
    number2: play.number2 ?? null,
  });
  const stake = Number(play.stake ?? 0);
  const payout = Number(play.payout ?? calculatePayout(play.type ?? 'fijo', stake));
  const typeLabel = String(play.type ?? '').toLowerCase();

  return {
    cat: 'results' as const,
    sev: 'success' as const,
    urgent: false,
    title: es ? '¡Una jugada tuya ganó!' : 'One of your plays won!',
    body: es
      ? `${typeLabel} · ${number} · $${stake} → $${payout.toLocaleString()}`
      : `${typeLabel} · ${number} · $${stake} → $${payout.toLocaleString()}`,
    meta: { playId: String(play.id ?? '') },
  };
}
